import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { isValid } from 'date-fns'

@Component({
  selector: 'flo-spotlight',
  styleUrls: ['./spotlight.component.scss'],
  templateUrl: './spotlight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightComponent {
  /** Returns true if the necessary information to show the component is present. */
  public get canDisplay(): boolean {
    return !!this.title && !!this.imageUrl
  }

  /** Returns true if the publish date is defined and a valid date */
  public get publishDateValid(): boolean {
    if (typeof this.publishDate === 'string') {
      throw Error('SpotlightComponent received string where it expected date.')
      return false
    }
    return this.publishDate != null && isValid(this.publishDate)
  }

  // Required Properties
  @Input() public title: string | undefined | null
  @Input() public imageUrl: string | undefined | null

  // Optional Properties
  @Input() public publishDate: Date | undefined | null
  @Input() public duration: number | undefined | null
  @Input() public premium = false
  @Input() public smallThumbnail = false
  @Input() public playingVideo = false
  @Input() public lightProBadge = false
}
